import React from "react";
import { Modal, Button, Input, Text } from "rizzui";
import { toast } from "sonner";
import { ExpirationService } from "../../../services/expiration/expirationService";

interface ImportSepaReturnsModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onImported: () => void;
}

const ImportSepaReturnsModal: React.FC<ImportSepaReturnsModalProps> = ({ isOpen, setIsOpen, onImported }) => {
  const [file, setFile] = React.useState<File | null>(null);
  const [bankName, setBankName] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [result, setResult] = React.useState<any>(null);

  const handleClose = () => {
    if (isLoading) return;
    setIsOpen(false);
    setFile(null);
    setBankName("");
    setResult(null);
  };

  const handleSubmit = async () => {
    if (!file) {
      toast.error("Debes seleccionar un archivo Excel");
      return;
    }

    setIsLoading(true);
    try {
      const response = await new ExpirationService().importSepaReturnsXLSX(file, bankName || undefined);
      const responseData = response.getResponseData();

      if (!responseData?.success) {
        toast.error(responseData?.message || "No se pudieron importar las devoluciones");
        return;
      }

      setResult(responseData?.data);

      const stats = responseData?.data?.stats;
      if (stats) {
        toast.success(`Importación completada: ${stats.reconciled ?? 0} conciliadas`);
      } else {
        toast.success("Importación completada");
      }

      if (responseData?.warning) {
        toast.warning(responseData.warning);
      }

      onImported();
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Error al importar devoluciones");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <div className="p-6 space-y-4">
        <Text className="text-lg font-semibold">Importar devoluciones (Excel)</Text>


        <div className="mb-4"> <span className="rizzui-input-label block text-sm mb-1.5 font-medium">Archivo</span></div>
        <input
          className="block w-full rounded border hover:border-primary focus:outline-primary px-3 py-2 text-sm"
          type="file"
          accept=".xls,.xlsx"
          onChange={(e) => setFile(e.target.files?.[0] ?? null)}
        />

        <Input
          label="Banco (opcional)"
          value={bankName}
          onChange={(e) => setBankName(e.target.value)}
          placeholder="BBVA / CaixaBank / etc."
        />

        {result?.stats && (
          <div className="rounded-md border p-3 text-sm">
            <Text className="font-medium">Resumen</Text>
            <div>Total filas: {result.stats.totalRows}</div>
            <div>Coincidencias: {result.stats.matched}</div>
            <div>Conciliadas: {result.stats.reconciled}</div>
            <div>Omitidas: {result.stats.skipped}</div>
            <div>Errores: {result.stats.errors}</div>
          </div>
        )}

        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={handleClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button color="primary" onClick={handleSubmit} isLoading={isLoading}>
            Importar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ImportSepaReturnsModal;

